<template>
  <div class="typography-hierarchy-content" id="identidade-visual-tipografia-hierarquia" data-search-anchor>
    <div class="title-typography-hierarchy-wrapper">
      <h1 class="typography-hierarchy-span">{{ typographyHierarchyTitleSpan }}</h1>
      <h1 class="typography-hierarchy-title">{{ typographyHierarchyTitle }}</h1>
    </div>    
    <div
      class="typography-hierarchy-card-item"
      :style="{ backgroundImage: `url(${typographyHierarchyImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class TypographyHierarchySection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyHierarchyTitleSpan(): string {
    return this.getElementTitle(4, 0)
  }

  get typographyHierarchyTitle(): string {
    return this.getElementText(4, 0)
  }

  get typographyHierarchyImageSrc(): string {
    return this.getElementMedia(4, 1)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typography-hierarchy-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-typography-hierarchy-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.typography-hierarchy-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typography-hierarchy-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.typography-hierarchy-icon {
  display: flex;
  align-items: center;
  margin-bottom: 6rem;
}

.typography-hierarchy-card-item {
  position: relative;  

  width: 100%;
  max-width: 1032px;
  height: 710px;
  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
